"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateLocationResponseDto = instanceOfUpdateLocationResponseDto;
exports.UpdateLocationResponseDtoFromJSON = UpdateLocationResponseDtoFromJSON;
exports.UpdateLocationResponseDtoFromJSONTyped = UpdateLocationResponseDtoFromJSONTyped;
exports.UpdateLocationResponseDtoToJSON = UpdateLocationResponseDtoToJSON;
exports.UpdateLocationResponseDtoToJSONTyped = UpdateLocationResponseDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateLocationResponseDto interface.
 */
function instanceOfUpdateLocationResponseDto(value) {
    if (!('timezoneId' in value) || value['timezoneId'] === undefined)
        return false;
    if (!('iana' in value) || value['iana'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('offsetLabel' in value) || value['offsetLabel'] === undefined)
        return false;
    if (!('autoTimezoneEnabled' in value) || value['autoTimezoneEnabled'] === undefined)
        return false;
    return true;
}
function UpdateLocationResponseDtoFromJSON(json) {
    return UpdateLocationResponseDtoFromJSONTyped(json, false);
}
function UpdateLocationResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timezoneId': json['timezoneId'],
        'iana': json['iana'],
        'displayName': json['displayName'],
        'offsetLabel': json['offsetLabel'],
        'autoTimezoneEnabled': json['autoTimezoneEnabled'],
    };
}
function UpdateLocationResponseDtoToJSON(json) {
    return UpdateLocationResponseDtoToJSONTyped(json, false);
}
function UpdateLocationResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'timezoneId': value['timezoneId'],
        'iana': value['iana'],
        'displayName': value['displayName'],
        'offsetLabel': value['offsetLabel'],
        'autoTimezoneEnabled': value['autoTimezoneEnabled'],
    };
}
